import * as React from 'react';
import {useCallback} from 'react';
import {TopicModule} from '@/services/pages/channel/channel.client';
import useJumpUrl from '@/hooks/useJumpUrl';
import {VALUE_TYPE} from '@/dicts/consts';
import styles from './index.less';

interface Props {
    page: string;
    sfRef?: string;
    channelBusinessLine?: string;
    infos: TopicModule;
}

const SelfTopicContentHorizontal = ({infos, page, channelBusinessLine}: Props) => {

    const {navigateToUrl} = useJumpUrl();

    const handleBannerJump = useCallback(
        (linkUrl?: string, card?) => {
            const urlParams = {
                linkUrl,
            };
            const logParams = {
                page: page,
                value: 'jump_neirong_henghua',
                channelId: infos?.channelId,
                pageType: channelBusinessLine,
                moduleId: infos?.moduleId,
                moduleName: infos?.moduleName,
                customize: {
                    // eslint-disable-next-line camelcase
                    value_type: VALUE_TYPE.ITEM,
                    // eslint-disable-next-line camelcase
                    value_id: card.itemId,
                    // eslint-disable-next-line camelcase
                    value_title: card.title,
                },
            };
            navigateToUrl(urlParams, logParams);
        },
        [channelBusinessLine, infos.channelId, infos.moduleId, infos.moduleName, page, navigateToUrl]
    );

    return (
        <div
            data-show={JSON.stringify({
                'page': page,
                'value': 'jump_neirong_henghua',
                'pageSourceId': infos.channelId,
                'pageType': channelBusinessLine,
                'valueId': infos.moduleId,
                'valueTitle': infos.moduleName,
                'valueType': VALUE_TYPE.MODULE,
            })}
        >

            {
                (infos.isShowTitle === 1 && (infos.moduleName || infos.moduleSubTitle))
                    ? (
                        <div className={styles.titleParent}>
                            <div className={styles.titleContent}>
                                {
                                    infos.moduleName
                                        ? (
                                            <span className={styles.title}>
                                                {infos.moduleName}
                                            </span>
                                        )
                                        : null
                                }
                                {
                                    infos.moduleSubTitle
                                        ? (
                                            <span className={styles.subTitle}>
                                                {infos.moduleSubTitle}
                                            </span>
                                        )
                                        : null
                                }
                            </div>
                            <div
                                onClick={() => {
                                    handleBannerJump(infos.moreUrl);
                                }}
                            >
                                {
                                    infos.moreUrl
                                        ? (
                                            <img
                                                onClick={() => {}}
                                                src={'https://med-fe.cdn.bcebos.com/content-external-channel/rightDirect.png'}
                                                className={styles.rightMoreArrow}
                                            />
                                        )
                                        : null
                                }
                            </div>
                        </div>
                    )
                    : null
            }

            <div className={styles.container}>

                {
                    infos.itemList?.map(
                        card => (
                            <div
                                key={card.itemId}
                                onClick={() => handleBannerJump(card.fieldValue?.link, card)}
                                data-show={JSON.stringify({
                                    'page': page,
                                    'value': 'jump_neirong_henghua',
                                    'pageSourceId': card.channelId,
                                    'pageType': channelBusinessLine,
                                    'valueId': card.itemId,
                                    'valueTitle': card.title,
                                    'valueType': VALUE_TYPE.ITEM,
                                })}
                            >

                                <div
                                    className={styles.card}
                                >
                                    <div style={{
                                        display: 'flex',
                                        // alignItems:'baseline'
                                    }}
                                    >

                                        {
                                            card?.fieldValue?.type === 2
                                                ? (
                                                    <img
                                                        onClick={() => {}}
                                                        src={'https://med-fe.cdn.bcebos.com/content-external-channel/play_small_green.png'}
                                                        className={styles.imgIcon}
                                                    />
                                                )
                                                : null
                                        }

                                        <span className={styles.cardTitle}>
                                            {card.fieldValue?.title}
                                        </span>

                                    </div>

                                </div>

                            </div>
                        ))
                }

            </div>

        </div>
    );
};

export default SelfTopicContentHorizontal;
